/**
 * companies/{id}.settings.autoJudgeReview — default true when absent.
 */

/**
 * @param {object|null|undefined} companyOrSettings
 * @returns {boolean}
 */
export function isAutoJudgeReviewEnabled(companyOrSettings) {
  const root =
    companyOrSettings && typeof companyOrSettings === 'object'
      ? companyOrSettings
      : {};
  const settings =
    root.settings && typeof root.settings === 'object' ? root.settings : root;
  if (settings.autoJudgeReview === false) return false;
  return true;
}

/**
 * @param {boolean} enabled
 * @returns {'pending_review'|'awaiting_judge_request'}
 */
export function initialSandboxStatusForAutoJudge(enabled) {
  return enabled ? 'pending_review' : 'awaiting_judge_request';
}

/** Judge / review fields cleared when requesting a fresh Automated QA run. */
export const JUDGE_VERDICT_CLEAR_FIELDS = Object.freeze([
  'judgeApproved',
  'judgeFeedback',
  'judgeLayer',
  'judgeModel',
  'judgeProvider',
  'judgeReviewedAt',
  'judgeSkippedReason',
  'judgeSkippedAt',
  'reviewedAt',
  'reviewedByUid',
  'reviewedByEmail',
  'reviewNote',
  'judgeRejectCategory',
  'pathJudgeRejectCap',
  'judgeHydrationMissCount',
  'judgeHydrationMisses',
]);
